import { createElementBlock as C, openBlock as n, createElementVNode as t } from "vue";
const l = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "svg__icon-ftva-online"
};
function o(i, e) {
  return n(), C("svg", l, e[0] || (e[0] = [
    t("path", {
      d: "M2.7 2.69999C2.46131 2.69999 2.23239 2.79482 2.0636 2.9636C1.89482 3.13238 1.8 3.3613 1.8 3.59999V11.7C1.8 11.9387 1.89482 12.1676 2.0636 12.3364C2.23239 12.5052 2.46131 12.6 2.7 12.6H15.3C15.5387 12.6 15.7676 12.5052 15.9364 12.3364C16.1052 12.1676 16.2 11.9387 16.2 11.7V3.59999C16.2 3.3613 16.1052 3.13238 15.9364 2.9636C15.7676 2.79482 15.5387 2.69999 15.3 2.69999H2.7ZM2.7 0.899994H15.3C16.0161 0.899994 16.7028 1.18446 17.2092 1.69081C17.7155 2.19715 18 2.88391 18 3.59999V11.7C18 12.4161 17.7155 13.1028 17.2092 13.6092C16.7028 14.1155 16.0161 14.4 15.3 14.4H2.7C1.98392 14.4 1.29716 14.1155 0.790812 13.6092C0.284463 13.1028 0 12.4161 0 11.7L0 3.59999C0 2.88391 0.284463 2.19715 0.790812 1.69081C1.29716 1.18446 1.98392 0.899994 2.7 0.899994ZM6.3 15.3H11.7C11.9387 15.3 12.1676 15.3948 12.3364 15.5636C12.5052 15.7324 12.6 15.9613 12.6 16.2C12.6 16.4387 12.5052 16.6676 12.3364 16.8364C12.1676 17.0052 11.9387 17.1 11.7 17.1H6.3C6.06131 17.1 5.83239 17.0052 5.6636 16.8364C5.49482 16.6676 5.4 16.4387 5.4 16.2C5.4 15.9613 5.49482 15.7324 5.6636 15.5636C5.83239 15.3948 6.06131 15.3 6.3 15.3Z",
      fill: "#555555",
      class: "svg__fill--medium-grey"
    }, null, -1)
  ]));
}
const s = { render: o };
export {
  s as default,
  o as render
};
